import { Component } from '@angular/core';

@Component({
  selector: 'zc-card-header',
  templateUrl: './card-header.component.html',
})
export class CardHeaderComponent {}
